import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { RouterLink } from '@angular/router';
import { BoschUiChipComponent } from '@intrack/bosch-ui-kit';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { InfoFieldModule } from '../info-field/info-field.module';
import { TranslateModule } from '@ngx-translate/core';
import { TimezoneModule } from '../timezone/timezone.module';
import { TrackingMapsRenderService } from './tracking-maps-render.service';
import { MapComponent } from './tracking-map/map/map.component';
import { TrackingMapComponent } from './tracking-map/tracking-map.component';
import { ShipmentOverviewMapContainerComponent } from './shipment-overview-tracking-map/shipment-overview-map-container.component';
import { TrackingMapCardComponent } from './tracking-map-card/tracking-map-card.component';
import { BaseTrackingMapComponent } from './base/base-tracking-map.component';
import { ShipmentsGlobalTrackingMapComponent } from './shipments-global-tracking-map/shipments-global-tracking-map.component';
import { DateWithProfileAndLocalTimezoneModule } from '../profile-and-local-date/date-with-profile-and-local-timezone.module';

@NgModule({
  declarations: [
    MapComponent,
    TrackingMapComponent,
    TrackingMapCardComponent,
    BaseTrackingMapComponent,
    ShipmentOverviewMapContainerComponent,
    ShipmentsGlobalTrackingMapComponent,
  ],
  imports: [
    CommonModule,
    SvgIconModule,
    IntrackFeatureModule,
    InfoFieldModule,
    GoogleMapsModule,
    TimezoneModule,
    TranslateModule.forChild({}),
    RouterLink,
    BoschUiChipComponent,
    DateWithProfileAndLocalTimezoneModule,
  ],
  exports: [
    TrackingMapComponent,
    TrackingMapCardComponent,
    ShipmentOverviewMapContainerComponent,
    ShipmentsGlobalTrackingMapComponent,
  ],
})
export class TrackingMapsModule {
  static forRoot(): ModuleWithProviders<TrackingMapsModule> {
    return {
      ngModule: TrackingMapsModule,
      providers: [TrackingMapsRenderService],
    };
  }
}
